import type { RouteObject } from "react-router";
import { AUTH_ROUTES } from "@/src/auth/constants/auth-routes";
import { AuthRouteLayout } from "@/src/auth/layouts/auth-route-layout";
import AuthPage from "@/src/auth/pages/auth-page";

export const authRoutes: RouteObject = {
	element: <AuthRouteLayout />,
	children: [{ path: AUTH_ROUTES.AUTH, element: <AuthPage /> }],
};
